import React from 'react';
import {
	CardContainer,
	Checkbox,
	InputField,
	Spinner,
} from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import {
	ActionContainer,
	Backdrop,
	CardContent,
	CardList,
	CompanyTitle,
	Container,
	ContainerModal,
	ContentContainer,
	DescriptionText,
	ErrorCheckbox,
	Footer,
	FormDescription,
	FormName,
	Modal,
	TitleContainer,
	TitleType,
	WarningAction,
	WarningText,
	Wrapper,
} from './NewCampaignSettingsModal.styles';
import Analytics from 'helpers/analytics';
import checklistIcon from 'App/assets/img/checklist-icon.png';
import {
	INewCampaignSettingsProps,
	useNewCampaignSettings,
} from './NewCampaignSettings.hooks';

export const NewCampaignSettingsModal = ({
	items,
	onClose,
	onContinue,
}: INewCampaignSettingsProps): JSX.Element => {
	const {
		isModalWarningVisible,
		isLoading,
		hasError,
		formSettings,
		user,
		setFormSettings,
		setModalWarningVisible,
		getFormNumber,
		handleSubmit,
		handleCheckbox,
	} = useNewCampaignSettings(onContinue, items);

	const handleClose = () => {
		Analytics.track('campaign', 'cancel-create-new-campaign');
		onClose();
	};

	return (
		<Wrapper>
			<Container>
				<TitleContainer>
					<h1>Crear nueva campaña</h1>
				</TitleContainer>
				<ContentContainer>
					<InputField
						id="campaignName"
						label="Nombre de la campaña"
						placeholder="Elige un nombre Ej. NOM 035 2022"
						error={hasError && !formSettings.name}
						value={formSettings.name}
						onChange={(value) =>
							setFormSettings({ ...formSettings, name: value })
						}
					/>
					<DescriptionText>
						Incluimos los cuestionarios que corresponden a{' '}
						<CompanyTitle>{user.company.fancyName}</CompanyTitle>, como lo
						señala la NOM-035 por el número de colaboradores
					</DescriptionText>
					{hasError && !formSettings.questionnaireIds.length && (
						<ErrorCheckbox>
							**Al menos un formulario debe estar marcado
						</ErrorCheckbox>
					)}
					<CardList>
						{items.map((card, index) => (
							<CardContainer
								key={card.name}
								height="124px"
								width="312px"
								type="horizontal"
								viewed
							>
								<CardContent>
									<ActionContainer>
										<img src={checklistIcon} />
										<div>
											<TitleType>{`Guía de referencia ${getFormNumber(
												index,
											)}`}</TitleType>
											<FormName>{card.name}</FormName>
										</div>
										<Checkbox
											size="small"
											topDistance="3px"
											onChange={(value) => handleCheckbox(value, card.id)}
											value={formSettings.questionnaireIds.includes(card.id)}
										/>
									</ActionContainer>
									<FormDescription>{card.description}</FormDescription>
								</CardContent>
							</CardContainer>
						))}
					</CardList>
				</ContentContainer>
				<Footer>
					<Button
						id="campaignSettingsCancel"
						disabled={isLoading}
						variant="outline"
						onClick={handleClose}
					>
						Cancelar
					</Button>
					<Button
						id="campaignSettingsConfirm"
						disabled={isLoading}
						onClick={handleSubmit}
					>
						{isLoading ? <Spinner /> : 'Continuar'}
					</Button>
				</Footer>
			</Container>

			{isModalWarningVisible && (
				<Modal>
					<ContainerModal>
						<WarningText>
							Este cuestionario es obligatorio segun tu número de empleados
						</WarningText>
						<WarningAction>
							<Button
								id="campaignSettingsWarningConfirm"
								width="130px"
								onClick={() => setModalWarningVisible(false)}
							>
								Comprendido
							</Button>
						</WarningAction>
					</ContainerModal>
					<Backdrop />
				</Modal>
			)}
		</Wrapper>
	);
};
